<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-22 15:57:46
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/index.vue
-->
<template>
  <div class="order_detail">
    <!-- titleBar -->
    <img src="@/assets/order/header_bg@2x.png" alt="" class="header_bg" />
    <div class="detail_con">
      <!-- icon_back_default_dark@2x -->
      <!-- icon_back@2x -->
      <div :style="bgStyle" class="bar_header">
        <img
          :src="opacityStyle.opacity !== 1 ? whiteGo : blackGo"
          alt=""
          class="icon_back left"
          @click="back"
        />
        <div
          :style="opacityStyle"
          class="font18 colo087 font_weight500 line_height_48"
          @click="back"
        >
          订单详情
        </div>
      </div>
      <!-- 头部信息 -->
      <div class="top_det">
        <header-det @clickBtn="clickBtn" @countDownFinish="getData" />
        <div v-if="getUserOrder.refundMessage" class="refund_message">
          {{ getUserOrder.refundMessage }}
        </div>
      </div>
      <!-- 地址信息 -->
      <div ref="addDet" class="top_address">
        <pickup-address-card
          v-if="getUserOrder.deliveryMode === 0"
          :pickupAddress="getUserOrder.pickupAddress"
          @contactService="contactService"
        />
        <address-det v-else />
      </div>
      <!-- 商品信息 -->
      <div class="product_con_det">
        <shop-header @goExplain="goExplain" />
        <!-- 商品信息 -->
        <div
          v-for="(item, index1) in getUserOrder.retailSubOrderList"
          :key="index1"
          :class="{ pad_mr: index1 !== 0 }"
          class="product_pad"
        >
          <div
            v-if="getUserOrder.retailSubOrderList.length > 1"
            :class="{ bao_mr: index1 !== 0 }"
            class="font12 font_weight500 colo087 text_left bao_name"
          >
            包裹{{ index1 + 1 }}
          </div>
          <!-- 包裹物流信息 -->
          <!-- <det-log-det
            v-if="item.trackingData && item.trackingData !== null"
            :trackingData="item.trackingData[0]"
          /> -->
          <!-- 商品信息 -->
          <div v-for="(i, index2) in item.orderDetailList" :key="index2">
            <order-product-list
              v-if="!i.isGift"
              :listIndex="index2"
              :pageShow="false"
              :item="i"
            />
            <!-- 赠品 -->
            <div v-if="i.isGift" class="free_product_list">
              <free-product :showBor="false" :freeProduct="i" />
            </div>
          </div>
          <!-- 底部按钮 -->
          <list-bottom-btn
            v-if="showPackageBtn(item)"
            :i="item"
            :item="getUserOrder"
            :packageIndex="index1"
            @clickBtn="
              (name, orderSn, subOrderSn, packageIndex, orderType, spuId) =>
                clickBtn(name, orderSn, packageIndex, subOrderSn, spuId)
            "
          />
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="det_det1">
        <order-product-det />
      </div>
      <!-- 订单价格 -->
      <order-price />
      <bottom-btn
        @cancelOrder="cancelOrder"
        @applyRefund="applyRefund"
        @clickBtn="clickBtn"
        :packageIndex="0"
      />
    </div>
    <cancel-action-sheet
      v-if="showCancel"
      @closeSheet="closeSheet"
      @confirmReasion="confirmReasion"
    />
    <!-- <pharmacist /> -->
  </div>
</template>
<script>
import HeaderDet from "./components/HeaderDet";
import AddressDet from "./components/AddressDet";
import ShopHeader from "./components/ShopHeader";
import OrderProductList from "../list/components/OrderProductList";
import FreeProduct from "./components/FreeProduct";
import OrderProductDet from "./components/OrderProductDet";
import OrderPrice from "./components/OrderPrice";
import CancelActionSheet from "./components/CancelActionSheet";
// import DetLogDet from "./components/DetLogDet";
import BottomBtn from "./components/BottomBtn";
import ListBottomBtn from "@/views/order/list/components/BottomBtn";
const PickupAddressCard = () =>
  import("@/views/order/purchase/components/PickupAddressCard");
export default {
  name: "OrderDetail",
  components: {
    HeaderDet,
    AddressDet,
    ShopHeader,
    OrderProductList,
    FreeProduct,
    OrderProductDet,
    OrderPrice,
    CancelActionSheet,
    // DetLogDet,
    ListBottomBtn,
    BottomBtn,
    PickupAddressCard
  },
  data() {
    return {
      showCancel: false,
      bgStyle: {
        backgroundColor: "rgba(255,255,255," + 0 + ")"
      },
      opacityStyle: {
        opacity: 0
      },
      whiteGo: require("@/assets/common/icon_back_default_dark@2x.png"),
      blackGo: require("@/assets/common/icon_back@2x.png")
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    },
    getSpuId() {
      const { retailSubOrderList } = this.$store.getters.getUserOrder;
      let spuId = "";
      if (retailSubOrderList) {
        retailSubOrderList.forEach(item => {
          if (item.orderDetailList) {
            item.orderDetailList.forEach(i => {
              if (!i.isGift) {
                spuId = i.spuId;
                return;
              }
            });
          }
        });
      }
      return spuId;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    //tabBar透明度
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      let detTo = this.$refs.addDet.offsetTop;
      // let detTo = 1000;
      let opacity = top / 500;
      opacity = opacity > 1 ? 1 : opacity;
      this.bgStyle = { backgroundColor: "rgba(255,255,255," + opacity + ")" };
      this.opacityStyle = { opacity };
      this.opacityName = { opacity };
      if (top < detTo) {
        this.opacityStyle = {
          opacity: opacity
        };
      } else {
        this.bgStyle = { backgroundColor: "rgba(255,255,255,1)" };
        this.opacityStyle = {
          opacity: 1
        };
      }
    },
    // getUserOrder
    // 获取数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      // console.log(params, "params");
      this.$store
        .dispatch("order/getUserOrder", { params })
        .then(() => {})
        .catch(() => {});
    },
    contactService() {
      const serviceContact = this.getUserOrder.serviceContact || "";
      if (!serviceContact) return;
      this.$dialog
        .confirm({
          title: "联系客服",
          message: serviceContact,
          confirmButtonText: "拨打",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          window.location.href = "tel:" + serviceContact;
        })
        .catch(() => {});
    },
    back() {
      this.$router.push({
        path: "/order/list"
      });
    },
    clickBar() {
      // console.log(232323);
    },
    // 取消接口
    cancelData(refundReason) {
      this.$store
        .dispatch("order/cancelOrder", {
          params: {
            orderSn: this.$route.query.orderSn,
            refundReason
          }
        })
        .then(() => {
          this.getData();
          this.showCancel = false;
          this.$toast("订单取消成功");
        })
        .catch(() => {});
    },
    // 删除接口
    deleteData() {
      this.$store
        .dispatch("order/deleteOrder", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(() => {
          this.$router.back();
          this.showCancel = false;
          this.$toast("订单删除成功");
        })
        .catch(() => {});
    },
    // 再次购买接口
    againBuy() {
      this.$store
        .dispatch("order/againBuy", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(() => {
          this.$router.push("/cart");
        })
        .catch(() => {});
    },
    // 确认收货
    confirmOrder(subOrderSn) {
      this.$store
        .dispatch("order/confirmOrder", {
          params: {
            subOrderSn
          }
        })
        .then(() => {
          this.getData();
        })
        .catch(() => {});
    },
    // 点击按钮
    clickBtn(name, orderSn, packageIndex, subOrderSn, spuId) {
      // console.log(name, orderSn, packageIndex, subOrderSn, 7777);
      switch (name) {
        case "取消订单":
          this.showCancel = true;
          break;
        case "去付款":
        case "重新支付":
          // /order/orderpay?orderSn=FY20112062347625
          this.$router.push({
            path: "/order/orderpay",
            query: {
              orderSn: this.getUserOrder.orderSn
            }
          });
          break;
        case "继续逛逛":
          this.$router.push("/home");
          break;
        case "修改地址":
          this.$toast("H5暂不支持修改订单地址，请前往全球购App操作");
          break;
        case "分享订单":
          this.$toast("H5暂不支持分享订单，请前往全球购App操作");
          break;
        case "查看物流":
          this.$router.push({
            path: "/order/detail/logistics",
            query: {
              orderSn: this.getUserOrder.orderSn,
              subOrderSn,
              packageIndex
            }
          });
          break;
        case "提醒发货":
          this.$toast("已提醒发货");
          break;
        case "申请退款":
          this.$router.push({
            path: "/order/refund/orderdetailrefundreasion",
            query: {
              orderSn: this.getUserOrder.orderSn,
              gmtCreate: this.getUserOrder.gmtCreate
            }
          });
          break;
        case "确认收货":
          this.$dialog
            .confirm({
              message: "您确定要确认收货吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              // 确认收货
              this.confirmOrder(subOrderSn);
            })
            .catch(() => {});
          break;
        case "再次购买":
          if (this.getUserOrder.orderType === 0) {
            this.againBuy();
          } else {
            // 跳转详情
            this.$router.push({
              path: "/product/detail",
              query: {
                id: spuId || this.getSpuId
              }
            });
          }
          break;
        case "申请售后":
          if (this.getUserOrder.orderType === 0) {
            this.$router.push({
              path: "/order/refund/applypackage",
              query: {
                orderType: this.getUserOrder.orderType,
                orderSn: this.getUserOrder.orderSn
              }
            });
          } else if (this.getUserOrder.orderType === 1) {
            // console.log(subOrderSn);
            // getPeriodOptionalAfterOrder 鲜奶可申请售后周期
            // this.$store
            //   .dispatch("order/getPeriodOptionalAfterOrder", {
            //     params: {
            //       orderSn: this.getUserOrder.orderSn
            //     }
            //   })
            //   .then(res => {
            //     console.log(res);
            // return;
            localStorage.setItem(
              "mall-wap-refund-type",
              this.getUserOrder.orderType
            );
            this.$router.push({
              path: "/order/refund/chooserefundtype",
              query: {
                orderType: this.getUserOrder.orderType,
                orderSn: this.getUserOrder.orderSn,
                subOrderSn: subOrderSn
              }
            });
            // })
            // .catch(() => {});
          }
          break;
        case "删除订单":
          this.$dialog
            .confirm({
              message: "您确定要删除该订单吗？",
              confirmButtonText: "确定",
              confirmButtonColor: "#DD9132"
            })
            .then(() => {
              this.deleteData();
            })
            .catch(() => {});
          break;
        case "配送计划":
          this.$router.push({
            path: "/order/milkplan",
            query: {
              orderSn: this.getUserOrder.orderSn,
              subOrderSn: this.getUserOrder.retailSubOrderList[0].subOrderSn
            }
          });
          break;
        case "前往使用":
          this.$router.push({
            path: "/mine/cardpackagelist"
          });
          break;
      }
    },
    // 取消订单
    cancelOrder() {
      this.showCancel = true;
    },
    // 配送计划
    milkPlan() {
      this.$router.push("/order/milkplan");
    },
    // 待发货申请退款
    applyRefund() {
      // 待发货
      // this.$router.push("/order/refund/orderdetailrefundreasion");
      // 发货后
      this.$router.push("/order/refund/applypackage");
    },
    closeSheet() {
      this.showCancel = false;
    },
    confirmReasion(refundReason) {
      this.cancelData(refundReason);
    },
    lookLogist() {
      this.$router.push("/order/detail/logistics");
    },
    isCloseStatus(status) {
      return status < 0 && status !== -5 && status !== -9;
    },
    showPackageBtn(item) {
      const status = item.status;
      if (status === 10) return false;
      if (this.isCloseStatus(status)) return false;
      return true;
    },
    // 发货说明
    goExplain() {
      if (this.getUserOrder.orderType === 1) {
        this.$router.push("/order/milkexplaintime");
      } else {
        this.$router.push("/order/explaintime");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.order_detail {
  position: relative;
  z-index: 1;
  .detail_con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    .bar_header {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      padding-right: 36px;
      z-index: 99;
      .icon_back {
        width: 24px;
        margin: 12px 0 0 12px;
        z-index: 100;
      }
    }
  }

  .header_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
  }
  .top_det {
    margin-top: 25px;
    .refund_message {
      color: #fff;
      font-size: 14px;
      padding: 6px 12px;
      text-align: left;
    }
  }
  .top_address {
    margin-top: 20px;
  }
  .product_con_det {
    background: #fff;
    margin-top: 12px;
    padding-bottom: 4px;
    .product_pad {
      padding-bottom: 9px;
      background: #fff;
    }
    .pad_mr {
      // margin-top: 10px;
      // border-top: 4px solid #f6f7f8;
    }
  }
  .free_product_list {
    background: #fff;
    margin: 0 12px;
  }
  //
  .bao_name {
    padding: 4px 12px;
  }
}
</style>
